"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _utils = require("../utils");

class Currencies {
  constructor(provider) {
    this.apiProvider = void 0;

    this.tokens = () => {
      return (0, _rxjs.of)([{
        name: 'DAI',
        symbol: 'DAI',
        precision: 18,
        isBaseToken: true,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.DAI.options.address.toLowerCase()
      }, {
        name: 'EUR',
        symbol: 'FEUR',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FEUR.options.address.toLowerCase()
      }, {
        name: 'JPY',
        symbol: 'FJPY',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FJPY.options.address.toLowerCase()
      }, {
        name: 'BTC',
        symbol: 'FBTC',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FBTC.options.address.toLowerCase()
      }, {
        name: 'ETH',
        symbol: 'FETH',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FETH.options.address.toLowerCase()
      }, {
        name: 'AUD',
        symbol: 'FAUD',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FAUD.options.address.toLowerCase()
      }, {
        name: 'CAD',
        symbol: 'FCAD',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FCAD.options.address.toLowerCase()
      }, {
        name: 'CHF',
        symbol: 'FCHF',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FCHF.options.address.toLowerCase()
      }, {
        name: 'XAU',
        symbol: 'FXAU',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FXAU.options.address.toLowerCase()
      }, {
        name: 'USOIL',
        symbol: 'FOIL',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FOIL.options.address.toLowerCase()
      }, {
        name: 'GBP',
        symbol: 'FGBP',
        precision: 18,
        isBaseToken: false,
        isNetworkToken: false,
        id: this.apiProvider.tokenContracts.FGBP.options.address.toLowerCase()
      }]);
    };

    this.convertAmountToBase = amount => {
      return (0, _rxjs.from)(this.apiProvider.baseContracts.moneyMarket.methods.convertAmountToBase(amount).call());
    };

    this.convertAmountFromBase = amount => {
      return (0, _rxjs.from)(this.apiProvider.baseContracts.moneyMarket.methods.convertAmountFromBase(amount).call().then());
    };

    this.exchangeRate = () => {
      return (0, _rxjs.from)(this.apiProvider.baseContracts.moneyMarket.methods.exchangeRate().call().then(result => (0, _utils.fixed18toNumber)(result)));
    };

    this.balances = address => {
      return this.tokens().pipe((0, _operators.switchMap)(tokens => {
        return (0, _rxjs.combineLatest)(...tokens.map(({
          id
        }) => this.apiProvider.getTokenContract(id).methods.balanceOf(address).call().then(result => {
          return {
            tokenId: id,
            free: result
          };
        })));
      }));
    };

    this.oracleValues = () => {
      return (0, _rxjs.timer)(0, 120000).pipe((0, _operators.switchMap)(() => this.tokens()), (0, _operators.switchMap)(tokens => {
        const timestamp = +new Date();
        return Promise.all(tokens.filter(token => !token.isNetworkToken && !token.isBaseToken).map(async ({
          id
        }) => {
          const value = await this.apiProvider.baseContracts.priceOracleInterface.methods.getPrice(id).call();
          return {
            tokenId: id,
            timestamp,
            value: value
          };
        }));
      }));
    };

    this.apiProvider = provider;
  }

}

var _default = Currencies;
exports.default = _default;